/**
 * Clears all personalized client-side storage on logout.
 *
 * NextAuth keeps the auth session in cookies, so wiping localStorage and
 * sessionStorage does not affect sign-out itself. This removes per-user
 * UI state, caches, onboarding/tour progress, watchlist selections, etc.
 */
export function clearClientStorageOnLogout(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.clear();
  } catch {}
  try {
    window.sessionStorage.clear();
  } catch {}
}
